module.exports = __webpack_public_path__ + "img/bust.4982c0bc.png";